export default "__VITE_ASSET__BTxfcxG___"